module.exports = __webpack_public_path__ + "static/HubSpot-90fd424aa4fdc47b24e59f04d07c94c9.png";